var city = {
  "citycode": [],
  "adcode": "130000",
  "name": "河北省",
  "center": {
      "lng": 114.530399,
      "lat": 38.037707
  },
  "districtList": [
      {
          "citycode": "0315",
          "adcode": "130200",
          "name": "唐山市",
          "center": {
              "lng": 118.180149,
              "lat": 39.63068
          },
          "districtList": [
              {
                  "citycode": "0315",
                  "adcode": "130225",
                  "name": "乐亭县",
                  "center": {
                      "lng": 118.91245,
                      "lat": 39.425748
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130229",
                  "name": "玉田县",
                  "center": {
                      "lng": 117.738196,
                      "lat": 39.901827
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130202",
                  "name": "路南区",
                  "center": {
                      "lng": 118.154348,
                      "lat": 39.624988
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130209",
                  "name": "曹妃甸区",
                  "center": {
                      "lng": 118.460197,
                      "lat": 39.273528
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130224",
                  "name": "滦南县",
                  "center": {
                      "lng": 118.68363,
                      "lat": 39.520272
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130205",
                  "name": "开平区",
                  "center": {
                      "lng": 118.262246,
                      "lat": 39.671634
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130204",
                  "name": "古冶区",
                  "center": {
                      "lng": 118.447134,
                      "lat": 39.73392
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130227",
                  "name": "迁西县",
                  "center": {
                      "lng": 118.31467,
                      "lat": 40.141486
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130284",
                  "name": "滦州市",
                  "center": {
                      "lng": 118.70301,
                      "lat": 39.740963
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130281",
                  "name": "遵化市",
                  "center": {
                      "lng": 117.965878,
                      "lat": 40.189119
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130207",
                  "name": "丰南区",
                  "center": {
                      "lng": 118.085169,
                      "lat": 39.576031
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130208",
                  "name": "丰润区",
                  "center": {
                      "lng": 118.162426,
                      "lat": 39.832919
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130203",
                  "name": "路北区",
                  "center": {
                      "lng": 118.201085,
                      "lat": 39.625079
                  }
              },
              {
                  "citycode": "0315",
                  "adcode": "130283",
                  "name": "迁安市",
                  "center": {
                      "lng": 118.701021,
                      "lat": 39.998861
                  }
              }
          ]
      },
      {
          "citycode": "0335",
          "adcode": "130300",
          "name": "秦皇岛市",
          "center": {
              "lng": 119.52022,
              "lat": 39.888243
          },
          "districtList": [
              {
                  "citycode": "0335",
                  "adcode": "130303",
                  "name": "山海关区",
                  "center": {
                      "lng": 119.775187,
                      "lat": 39.978882
                  }
              },
              {
                  "citycode": "0335",
                  "adcode": "130306",
                  "name": "抚宁区",
                  "center": {
                      "lng": 119.244847,
                      "lat": 39.876253
                  }
              },
              {
                  "citycode": "0335",
                  "adcode": "130302",
                  "name": "海港区",
                  "center": {
                      "lng": 119.564962,
                      "lat": 39.94756
                  }
              },
              {
                  "citycode": "0335",
                  "adcode": "130304",
                  "name": "北戴河区",
                  "center": {
                      "lng": 119.48449,
                      "lat": 39.834912
                  }
              },
              {
                  "citycode": "0335",
                  "adcode": "130321",
                  "name": "青龙满族自治县",
                  "center": {
                      "lng": 118.94985,
                      "lat": 40.407473
                  }
              },
              {
                  "citycode": "0335",
                  "adcode": "130322",
                  "name": "昌黎县",
                  "center": {
                      "lng": 119.199846,
                      "lat": 39.699677
                  }
              },
              {
                  "citycode": "0335",
                  "adcode": "130324",
                  "name": "卢龙县",
                  "center": {
                      "lng": 118.891931,
                      "lat": 39.892564
                  }
              }
          ]
      },
      {
          "citycode": "0314",
          "adcode": "130800",
          "name": "承德市",
          "center": {
              "lng": 117.962749,
              "lat": 40.952942
          },
          "districtList": [
              {
                  "citycode": "0314",
                  "adcode": "130828",
                  "name": "围场满族蒙古族自治县",
                  "center": {
                      "lng": 117.75934,
                      "lat": 41.938372
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130826",
                  "name": "丰宁满族自治县",
                  "center": {
                      "lng": 116.645798,
                      "lat": 41.209951
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130825",
                  "name": "隆化县",
                  "center": {
                      "lng": 117.739026,
                      "lat": 41.314402
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130827",
                  "name": "宽城满族自治县",
                  "center": {
                      "lng": 118.485472,
                      "lat": 40.611333
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130804",
                  "name": "鹰手营子矿区",
                  "center": {
                      "lng": 117.659341,
                      "lat": 40.546424
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130824",
                  "name": "滦平县",
                  "center": {
                      "lng": 117.332652,
                      "lat": 40.941644
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130803",
                  "name": "双滦区",
                  "center": {
                      "lng": 117.799588,
                      "lat": 40.959426
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130802",
                  "name": "双桥区",
                  "center": {
                      "lng": 117.943121,
                      "lat": 40.974679
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130821",
                  "name": "承德县",
                  "center": {
                      "lng": 118.174166,
                      "lat": 40.768082
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130822",
                  "name": "兴隆县",
                  "center": {
                      "lng": 117.500558,
                      "lat": 40.417358
                  }
              },
              {
                  "citycode": "0314",
                  "adcode": "130881",
                  "name": "平泉市",
                  "center": {
                      "lng": 118.702032,
                      "lat": 41.018482
                  }
              }
          ]
      },
      {
          "citycode": "0311",
          "adcode": "130100",
          "name": "石家庄市",
          "center": {
              "lng": 114.514976,
              "lat": 38.042007
          },
          "districtList": [
              {
                  "citycode": "0311",
                  "adcode": "130126",
                  "name": "灵寿县",
                  "center": {
                      "lng": 114.383013,
                      "lat": 38.307908
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130183",
                  "name": "晋州市",
                  "center": {
                      "lng": 115.044141,
                      "lat": 38.033937
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130132",
                  "name": "元氏县",
                  "center": {
                      "lng": 114.525508,
                      "lat": 37.767332
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130127",
                  "name": "高邑县",
                  "center": {
                      "lng": 114.611659,
                      "lat": 37.615905
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130123",
                  "name": "正定县",
                  "center": {
                      "lng": 114.57043,
                      "lat": 38.14699
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130184",
                  "name": "新乐市",
                  "center": {
                      "lng": 114.683745,
                      "lat": 38.343952
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130181",
                  "name": "辛集市",
                  "center": {
                      "lng": 115.217626,
                      "lat": 37.943239
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130107",
                  "name": "井陉矿区",
                  "center": {
                      "lng": 114.062258,
                      "lat": 38.065446
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130121",
                  "name": "井陉县",
                  "center": {
                      "lng": 114.145669,
                      "lat": 38.032366
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130128",
                  "name": "深泽县",
                  "center": {
                      "lng": 115.20089,
                      "lat": 38.184572
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130133",
                  "name": "赵县",
                  "center": {
                      "lng": 114.775914,
                      "lat": 37.756935
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130125",
                  "name": "行唐县",
                  "center": {
                      "lng": 114.553044,
                      "lat": 38.437535
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130105",
                  "name": "新华区",
                  "center": {
                      "lng": 114.463904,
                      "lat": 38.050749
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130110",
                  "name": "鹿泉区",
                  "center": {
                      "lng": 114.313559,
                      "lat": 38.086536
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130131",
                  "name": "平山县",
                  "center": {
                      "lng": 114.186007,
                      "lat": 38.260288
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130104",
                  "name": "桥西区",
                  "center": {
                      "lng": 114.45004,
                      "lat": 38.025245
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130111",
                  "name": "栾城区",
                  "center": {
                      "lng": 114.647922,
                      "lat": 37.900915
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130108",
                  "name": "裕华区",
                  "center": {
                      "lng": 114.531599,
                      "lat": 38.007002
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130109",
                  "name": "藁城区",
                  "center": {
                      "lng": 114.846562,
                      "lat": 38.022177
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130102",
                  "name": "长安区",
                  "center": {
                      "lng": 114.538955,
                      "lat": 38.03682
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130130",
                  "name": "无极县",
                  "center": {
                      "lng": 114.976256,
                      "lat": 38.178852
                  }
              },
              {
                  "citycode": "0311",
                  "adcode": "130129",
                  "name": "赞皇县",
                  "center": {
                      "lng": 114.386114,
                      "lat": 37.666549
                  }
              }
          ]
      },
      {
          "citycode": "0316",
          "adcode": "131000",
          "name": "廊坊市",
          "center": {
              "lng": 116.683546,
              "lat": 39.538304
          },
          "districtList": [
              {
                  "citycode": "0316",
                  "adcode": "131028",
                  "name": "大厂回族自治县",
                  "center": {
                      "lng": 116.98961,
                      "lat": 39.886569
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131026",
                  "name": "文安县",
                  "center": {
                      "lng": 116.457628,
                      "lat": 38.873185
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131082",
                  "name": "三河市",
                  "center": {
                      "lng": 117.078269,
                      "lat": 39.982933
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131081",
                  "name": "霸州市",
                  "center": {
                      "lng": 116.391488,
                      "lat": 39.125238
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131022",
                  "name": "固安县",
                  "center": {
                      "lng": 116.298696,
                      "lat": 39.438797
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131025",
                  "name": "大城县",
                  "center": {
                      "lng": 116.653917,
                      "lat": 38.705232
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131023",
                  "name": "永清县",
                  "center": {
                      "lng": 116.50608,
                      "lat": 39.330983
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131002",
                  "name": "安次区",
                  "center": {
                      "lng": 116.694544,
                      "lat": 39.502569
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131003",
                  "name": "广阳区",
                  "center": {
                      "lng": 116.710667,
                      "lat": 39.52343
                  }
              },
              {
                  "citycode": "0316",
                  "adcode": "131024",
                  "name": "香河县",
                  "center": {
                      "lng": 117.006072,
                      "lat": 39.763772
                  }
              }
          ]
      },
      {
          "citycode": "0318",
          "adcode": "131100",
          "name": "衡水市",
          "center": {
              "lng": 115.668987,
              "lat": 37.739367
          },
          "districtList": [
              {
                  "citycode": "0318",
                  "adcode": "131102",
                  "name": "桃城区",
                  "center": {
                      "lng": 115.675208,
                      "lat": 37.735152
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131182",
                  "name": "深州市",
                  "center": {
                      "lng": 115.559576,
                      "lat": 38.001535
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131128",
                  "name": "阜城县",
                  "center": {
                      "lng": 116.175424,
                      "lat": 37.862984
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131103",
                  "name": "冀州区",
                  "center": {
                      "lng": 115.579392,
                      "lat": 37.550922
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131126",
                  "name": "故城县",
                  "center": {
                      "lng": 115.965877,
                      "lat": 37.347873
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131122",
                  "name": "武邑县",
                  "center": {
                      "lng": 115.887498,
                      "lat": 37.802036
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131123",
                  "name": "武强县",
                  "center": {
                      "lng": 115.982119,
                      "lat": 38.041447
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131121",
                  "name": "枣强县",
                  "center": {
                      "lng": 115.724365,
                      "lat": 37.514217
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131124",
                  "name": "饶阳县",
                  "center": {
                      "lng": 115.725898,
                      "lat": 38.235313
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131125",
                  "name": "安平县",
                  "center": {
                      "lng": 115.518918,
                      "lat": 38.234769
                  }
              },
              {
                  "citycode": "0318",
                  "adcode": "131127",
                  "name": "景县",
                  "center": {
                      "lng": 116.270558,
                      "lat": 37.692831
                  }
              }
          ]
      },
      {
          "citycode": "0313",
          "adcode": "130700",
          "name": "张家口市",
          "center": {
              "lng": 114.885895,
              "lat": 40.768931
          },
          "districtList": [
              {
                  "citycode": "0313",
                  "adcode": "130723",
                  "name": "康保县",
                  "center": {
                      "lng": 114.60018,
                      "lat": 41.853016
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130732",
                  "name": "赤城县",
                  "center": {
                      "lng": 115.831256,
                      "lat": 40.913348
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130709",
                  "name": "崇礼区",
                  "center": {
                      "lng": 115.282345,
                      "lat": 40.974741
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130706",
                  "name": "下花园区",
                  "center": {
                      "lng": 115.287127,
                      "lat": 40.502628
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130731",
                  "name": "涿鹿县",
                  "center": {
                      "lng": 115.196835,
                      "lat": 40.382681
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130702",
                  "name": "桥东区",
                  "center": {
                      "lng": 114.894114,
                      "lat": 40.788472
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130705",
                  "name": "宣化区",
                  "center": {
                      "lng": 115.099515,
                      "lat": 40.609444
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130726",
                  "name": "蔚县",
                  "center": {
                      "lng": 114.589136,
                      "lat": 39.840154
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130728",
                  "name": "怀安县",
                  "center": {
                      "lng": 114.386488,
                      "lat": 40.67527
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130703",
                  "name": "桥西区",
                  "center": {
                      "lng": 114.868604,
                      "lat": 40.819553
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130725",
                  "name": "尚义县",
                  "center": {
                      "lng": 113.968763,
                      "lat": 41.076588
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130722",
                  "name": "张北县",
                  "center": {
                      "lng": 114.719927,
                      "lat": 41.159039
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130708",
                  "name": "万全区",
                  "center": {
                      "lng": 114.740584,
                      "lat": 40.767377
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130730",
                  "name": "怀来县",
                  "center": {
                      "lng": 115.517868,
                      "lat": 40.415625
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130727",
                  "name": "阳原县",
                  "center": {
                      "lng": 114.150267,
                      "lat": 40.104303
                  }
              },
              {
                  "citycode": "0313",
                  "adcode": "130724",
                  "name": "沽源县",
                  "center": {
                      "lng": 115.688544,
                      "lat": 41.670497
                  }
              }
          ]
      },
      {
          "citycode": "0312",
          "adcode": "130600",
          "name": "保定市",
          "center": {
              "lng": 115.464523,
              "lat": 38.874476
          },
          "districtList": [
              {
                  "citycode": "0312",
                  "adcode": "130636",
                  "name": "顺平县",
                  "center": {
                      "lng": 115.135133,
                      "lat": 38.837988
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130632",
                  "name": "安新县",
                  "center": {
                      "lng": 115.935688,
                      "lat": 38.936102
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130683",
                  "name": "安国市",
                  "center": {
                      "lng": 115.327088,
                      "lat": 38.418985
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130623",
                  "name": "涞水县",
                  "center": {
                      "lng": 115.713651,
                      "lat": 39.394305
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130624",
                  "name": "阜平县",
                  "center": {
                      "lng": 114.195118,
                      "lat": 38.849221
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130631",
                  "name": "望都县",
                  "center": {
                      "lng": 115.15542,
                      "lat": 38.696221
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130627",
                  "name": "唐县",
                  "center": {
                      "lng": 114.982968,
                      "lat": 38.748477
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130684",
                  "name": "高碑店市",
                  "center": {
                      "lng": 115.873612,
                      "lat": 39.327233
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130626",
                  "name": "定兴县",
                  "center": {
                      "lng": 115.808183,
                      "lat": 39.263219
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130629",
                  "name": "容城县",
                  "center": {
                      "lng": 115.861635,
                      "lat": 39.043321
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130638",
                  "name": "雄县",
                  "center": {
                      "lng": 116.108624,
                      "lat": 38.994825
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130634",
                  "name": "曲阳县",
                  "center": {
                      "lng": 114.740476,
                      "lat": 38.614409
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130637",
                  "name": "博野县",
                  "center": {
                      "lng": 115.464295,
                      "lat": 38.458048
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130628",
                  "name": "高阳县",
                  "center": {
                      "lng": 115.779149,
                      "lat": 38.700846
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130635",
                  "name": "蠡县",
                  "center": {
                      "lng": 115.583701,
                      "lat": 38.488064
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130681",
                  "name": "涿州市",
                  "center": {
                      "lng": 115.97444,
                      "lat": 39.485684
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130630",
                  "name": "涞源县",
                  "center": {
                      "lng": 114.694416,
                      "lat": 39.360622
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130606",
                  "name": "莲池区",
                  "center": {
                      "lng": 115.497153,
                      "lat": 38.883528
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130608",
                  "name": "清苑区",
                  "center": {
                      "lng": 115.48988,
                      "lat": 38.76527
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130682",
                  "name": "定州市",
                  "center": {
                      "lng": 114.990321,
                      "lat": 38.516746
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130609",
                  "name": "徐水区",
                  "center": {
                      "lng": 115.655772,
                      "lat": 39.018781
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130633",
                  "name": "易县",
                  "center": {
                      "lng": 115.497487,
                      "lat": 39.350219
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130607",
                  "name": "满城区",
                  "center": {
                      "lng": 115.322246,
                      "lat": 38.949732
                  }
              },
              {
                  "citycode": "0312",
                  "adcode": "130602",
                  "name": "竞秀区",
                  "center": {
                      "lng": 115.458671,
                      "lat": 38.877318
                  }
              }
          ]
      },
      {
          "citycode": "0319",
          "adcode": "130500",
          "name": "邢台市",
          "center": {
              "lng": 114.49742,
              "lat": 37.060227
          },
          "districtList": [
              {
                  "citycode": "0319",
                  "adcode": "130581",
                  "name": "南宫市",
                  "center": {
                      "lng": 115.40866,
                      "lat": 37.358907
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130506",
                  "name": "南和区",
                  "center": {
                      "lng": 114.683683,
                      "lat": 37.005626
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130530",
                  "name": "新河县",
                  "center": {
                      "lng": 115.251005,
                      "lat": 37.520891
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130524",
                  "name": "柏乡县",
                  "center": {
                      "lng": 114.693447,
                      "lat": 37.48288
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130534",
                  "name": "清河县",
                  "center": {
                      "lng": 115.665081,
                      "lat": 37.0451
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130533",
                  "name": "威县",
                  "center": {
                      "lng": 115.266829,
                      "lat": 36.975164
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130535",
                  "name": "临西县",
                  "center": {
                      "lng": 115.501258,
                      "lat": 36.871312
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130582",
                  "name": "沙河市",
                  "center": {
                      "lng": 114.503023,
                      "lat": 36.855548
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130523",
                  "name": "内丘县",
                  "center": {
                      "lng": 114.512226,
                      "lat": 37.287612
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130505",
                  "name": "任泽区",
                  "center": {
                      "lng": 114.671339,
                      "lat": 37.121958
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130522",
                  "name": "临城县",
                  "center": {
                      "lng": 114.498651,
                      "lat": 37.444512
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130529",
                  "name": "巨鹿县",
                  "center": {
                      "lng": 115.037884,
                      "lat": 37.221293
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130525",
                  "name": "隆尧县",
                  "center": {
                      "lng": 114.770509,
                      "lat": 37.351232
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130531",
                  "name": "广宗县",
                  "center": {
                      "lng": 115.142766,
                      "lat": 37.074795
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130532",
                  "name": "平乡县",
                  "center": {
                      "lng": 115.03008,
                      "lat": 37.063771
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130502",
                  "name": "襄都区",
                  "center": {
                      "lng": 114.507443,
                      "lat": 37.071314
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130503",
                  "name": "信都区",
                  "center": {
                      "lng": 114.468229,
                      "lat": 37.093798
                  }
              },
              {
                  "citycode": "0319",
                  "adcode": "130528",
                  "name": "宁晋县",
                  "center": {
                      "lng": 114.940006,
                      "lat": 37.624524
                  }
              }
          ]
      },
      {
          "citycode": "0310",
          "adcode": "130400",
          "name": "邯郸市",
          "center": {
              "lng": 114.53915,
              "lat": 36.625849
          },
          "districtList": [
              {
                  "citycode": "0310",
                  "adcode": "130407",
                  "name": "肥乡区",
                  "center": {
                      "lng": 114.800199,
                      "lat": 36.548545
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130431",
                  "name": "鸡泽县",
                  "center": {
                      "lng": 114.889951,
                      "lat": 36.911525
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130408",
                  "name": "永年区",
                  "center": {
                      "lng": 114.536626,
                      "lat": 36.74188
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130423",
                  "name": "临漳县",
                  "center": {
                      "lng": 114.585514,
                      "lat": 36.322504
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130402",
                  "name": "邯山区",
                  "center": {
                      "lng": 114.531062,
                      "lat": 36.59457
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130425",
                  "name": "大名县",
                  "center": {
                      "lng": 115.147985,
                      "lat": 36.286406
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130403",
                  "name": "丛台区",
                  "center": {
                      "lng": 114.492875,
                      "lat": 36.636434
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130404",
                  "name": "复兴区",
                  "center": {
                      "lng": 114.462581,
                      "lat": 36.638879
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130435",
                  "name": "曲周县",
                  "center": {
                      "lng": 114.957549,
                      "lat": 36.766347
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130481",
                  "name": "武安市",
                  "center": {
                      "lng": 114.203685,
                      "lat": 36.69759
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130432",
                  "name": "广平县",
                  "center": {
                      "lng": 114.921185,
                      "lat": 36.476727
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130424",
                  "name": "成安县",
                  "center": {
                      "lng": 114.670094,
                      "lat": 36.445331
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130433",
                  "name": "馆陶县",
                  "center": {
                      "lng": 115.281818,
                      "lat": 36.548295
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130430",
                  "name": "邱县",
                  "center": {
                      "lng": 115.200049,
                      "lat": 36.811783
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130426",
                  "name": "涉县",
                  "center": {
                      "lng": 113.692157,
                      "lat": 36.586073
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130434",
                  "name": "魏县",
                  "center": {
                      "lng": 114.939217,
                      "lat": 36.35926
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130406",
                  "name": "峰峰矿区",
                  "center": {
                      "lng": 114.212571,
                      "lat": 36.419298
                  }
              },
              {
                  "citycode": "0310",
                  "adcode": "130427",
                  "name": "磁县",
                  "center": {
                      "lng": 114.373965,
                      "lat": 36.37507
                  }
              }
          ]
      },
      {
          "citycode": "0317",
          "adcode": "130900",
          "name": "沧州市",
          "center": {
              "lng": 116.838715,
              "lat": 38.304676
          },
          "districtList": [
              {
                  "citycode": "0317",
                  "adcode": "130924",
                  "name": "海兴县",
                  "center": {
                      "lng": 117.497545,
                      "lat": 38.143308
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130982",
                  "name": "任丘市",
                  "center": {
                      "lng": 116.084412,
                      "lat": 38.685325
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130923",
                  "name": "东光县",
                  "center": {
                      "lng": 116.537138,
                      "lat": 37.888844
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130928",
                  "name": "吴桥县",
                  "center": {
                      "lng": 116.391557,
                      "lat": 37.628225
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130902",
                  "name": "新华区",
                  "center": {
                      "lng": 116.866309,
                      "lat": 38.314094
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130903",
                  "name": "运河区",
                  "center": {
                      "lng": 116.842964,
                      "lat": 38.283456
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130921",
                  "name": "沧县",
                  "center": {
                      "lng": 117.007478,
                      "lat": 38.219856
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130930",
                  "name": "孟村回族自治县",
                  "center": {
                      "lng": 117.104514,
                      "lat": 38.053438
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130925",
                  "name": "盐山县",
                  "center": {
                      "lng": 117.230681,
                      "lat": 38.058074
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130927",
                  "name": "南皮县",
                  "center": {
                      "lng": 116.708603,
                      "lat": 38.038761
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130922",
                  "name": "青县",
                  "center": {
                      "lng": 116.804137,
                      "lat": 38.583657
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130926",
                  "name": "肃宁县",
                  "center": {
                      "lng": 115.829619,
                      "lat": 38.423044
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130984",
                  "name": "河间市",
                  "center": {
                      "lng": 116.099362,
                      "lat": 38.446656
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130981",
                  "name": "泊头市",
                  "center": {
                      "lng": 116.578322,
                      "lat": 38.084262
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130929",
                  "name": "献县",
                  "center": {
                      "lng": 116.122767,
                      "lat": 38.189924
                  }
              },
              {
                  "citycode": "0317",
                  "adcode": "130983",
                  "name": "黄骅市",
                  "center": {
                      "lng": 117.330043,
                      "lat": 38.372266
                  }
              }
          ]
      }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/hebei.js